interface LanguagePickerProps {
  selectedLanguage: string;
  onChange: (language: string) => void;
  disabled?: boolean;
}

export default function LanguagePicker({
  selectedLanguage,
  onChange,
  disabled = false,
}: LanguagePickerProps) {
  return (
    <div className="segmented-control">
      <button
        type="button"
        className={`template-button ${
          selectedLanguage === "german" ? "selected" : ""
        }`}
        onClick={() => onChange("german")}
        disabled={disabled}
      >
        Deutsch
      </button>

      <button
        type="button"
        className={`template-button ${
          selectedLanguage === "english" ? "selected" : ""
        }`}
        onClick={() => onChange("english")}
        disabled={disabled}
      >
        Englisch
      </button>
    </div>
  );
}